import { render } from "./RequestPermissionPropsCmp.vue?vue&type=template&id=12e65598"
import script from "./RequestPermissionPropsCmp.vue?vue&type=script&lang=js"
export * from "./RequestPermissionPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__